//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import { clientQuery } from 'Core/data/GraphQLApi';
//```import constants types
import {
    VIDFLEET_SHOW_CHANGES_HISTORY_LIST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';

import {
    showChangesHistoryGetDataResult
} from 'Redux/actions';

function* showChangesHistoryList({ payload }) {
    try {
        const { filters } = payload;

        if (filters.esn) {
            let QUERY = `
                query getCameraConfigureHistory($esn: String!){
                    result: getCameraConfigureHistory(esn: $esn)
                }
            `

            let data = yield call(
                clientQuery,
                QUERY,
                {
                    esn: filters.esn
                },
                endpoints.GRAPHQL_GENERAL,
            );

            if (data?.result) {
                let resultGeneral = JSON.parse(data?.result)
                if (resultGeneral && resultGeneral?.configureChangeHistory) {
                    result?.configureChangeHistory.map((item, index) => {
                        if (item.previousVersion) {
                            item.lastChange = result?.configureChangeHistory.find(x => x.version === item.previousVersion);
                        }
                        return item;
                    })
                }
                yield put(showChangesHistoryGetDataResult({ resultGeneral, error: null }));
            }
        }
    } catch (exc) {
        yield put(showChangesHistoryGetDataResult({ error: true, errorCode: exc.request?.status }));
        ExceptionManager(
            exc,
            "Modules/vidFleet/.components/showChangesHistory/redux/saga",
            "showChangesHistoryList"
        )
    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_SHOW_CHANGES_HISTORY_LIST, showChangesHistoryList);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}